// extracted by mini-css-extract-plugin
export default {"wrapper":"unloadingZip_wrapper__V4Ghm"};